
import { Getter } from 'vuex-class'
import { Component, Vue } from 'vue-property-decorator'
import { handleFill, copyText, moneyFormat, getArriveInfoTime } from '@/utils/util'
import PickupCode from './components/pickup-code.vue'
import Price from '@/components/Price/index.vue'
import { getOrderDtlNew } from '@/api/industryMall'
import dayjs from 'dayjs'

Component.registerHooks(['beforeRouteLeave']);
@Component({
  components: {
    PickupCode,
    Price
  }
})
class WeiDianOrderDetail extends Vue {
  @Getter companyId!: string
  @Getter info!: any
  handleFill = handleFill
  copyText = copyText
  moneyFormat = moneyFormat

  // 0待支付，1待取货，3已完成，-1已取消单
  // 已取消订单包含退款/退货
  statusOptions = [
    { name: '待支付', value: 0, icon: 'clock-circle.png', marginRight: 0 },
    { name: '待取货', value: 1, icon: 'clock-circle.png', marginRight: 0 },
    { name: '已完成', value: 3, icon: 'check-circle.png', marginRight: 0 },
    { name: '已取消', value: -1, icon: 'check-circle.png', marginRight: 0 }
  ]

  orderId = ''
  detailData: any = {}
  isShowAll = false
  createNum = 5

  get navbarTitleObj () {
    let { orderStatus = 0 } = this.detailData || {}
    orderStatus = Number(orderStatus)
    const index = this.statusOptions.findIndex((status: any) => status.value === orderStatus)
    return this.statusOptions[index === -1 ? 0 : index]
  }

  get goodsList () {
    return this.detailData?.goodsList || []
  }

  get sftpUrl () {
    return this.$store.state.user.sftpUrl
  }

  mounted () {
    const params = {
      orderId: this.$route.query.orderId
    }
    // 获取订单详情数据
    getOrderDtlNew(params).then((res: any) => {
      this.detailData = res?.data || {}
    })
  }

  beforeRouteLeave (to, from, next) {
    to.query.active = 1
    to.query.curTab = from.query.curTab
    next();
  }

  formatDeliveryDate (deliveryDate: string) {
    return handleFill(dayjs(deliveryDate).format("YYYY年MM月DD日"))
  }

  onShowAll () {
    this.isShowAll = !this.isShowAll
  }

  toDetail (goods) {
    // 无码商品不允许跳转， 后端固定返回 goodsId 9999999999999
    if (goods.goodsId === '9999999999999') return
    this.$router.push({
      path: "/addGoods",
      query: {
        type: "edit",
        goodsId: goods.goodsId,
      },
    });
  }
}
export default WeiDianOrderDetail
